import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  UPLOAD_PERCENTAGE,
  UPLOAD_PROGRESS_VISIBILITY,
  UPLOAD_FILE_SUCCESS,
  REMOVE_FILE_SUCCESS,
  LOAD_CLAIM_ATTACHMENTS_SUCCESS,
  RESET,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    attachDocuments: [],
    uploadPercentage: 0,
    progressBarVisibility: false,
  },
});

function step12Reducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload }) : initialState;
    case UPLOAD_PERCENTAGE:
      return state.setIn(['form', 'uploadPercentage'], action.percent);
    case UPLOAD_PROGRESS_VISIBILITY:
      return state.setIn(['form', 'progressBarVisibility'], action.visible);
    case UPLOAD_FILE_SUCCESS:
      return state.setIn(
        ['form', 'attachDocuments'],
        state.getIn(['form', 'attachDocuments']).push(action.file)
      );
    case REMOVE_FILE_SUCCESS:
      return state.setIn(
        ['form', 'attachDocuments'],
        fromJS(
          state
            .getIn(['form', 'attachDocuments'])
            .toJS()
            .filter((file) => file.id !== action.file.id)
        ));
    case LOAD_CLAIM_ATTACHMENTS_SUCCESS:
      return state
        .setIn(
          ['form', 'attachDocuments'],
          fromJS(
            action.files.map((file) => ({
              id: file.id,
              name: file.fileName,
              benefitCode: file.benefitCode,
            }))
          )
        );
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default step12Reducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step12/reducer.js